import React from 'react';
import BusCoordinates from "./BusCoordinates";

export default function Buses({busesLocations, routeOptions, color}) {
    return busesLocations.map(busLocation => {
        const {coordinates, isActive} = busLocation;
        return <BusCoordinates key={coordinates} coordinates={coordinates} routeOptions={routeOptions} isActive={isActive} color={color} {...busLocation}/>
    });
}
